import React, { FunctionComponent } from 'react';
import { Box, Grid } from '@material-ui/core';
import useSelectedCurrencyPrice from '../../../../../../../../gqlCommon/hooks/currency/useSelectedCurrencyPrice';
import IPrice from '../../../../../../../../gqlCommon/model/prices/IPrice';
import SummaryLabelTitle from '../../../summaryLabel/SummaryLabelTitle';
import PriceValue from '../priceValue/PriceValue';
import summaryLabelStyles from '../../../summaryLabel/SummaryLabelStyles';
import Translation from '../../../../../../../../gqlCommon/components/translation/Translation';
import IndicativeNumber from '../../../../../../../../gqlCommon/components/indicativeNumber/IndicativeNumber';
import useScrollToSection from '../../../../../../../hooks/navigation/useScrollToSection';
import { PriceDisplayType } from '../../../../../../../../../../common/enum/PriceDisplayType';
import clsx from 'clsx';

export interface ISelectionProps {
  prices: IPrice[];
  currency: string;
  loading?: boolean;
  boldLabel?: boolean;
  summaryLabel?: JSX.Element;
  taxLabel?: string;
}

const SummarySelection: FunctionComponent<ISelectionProps> = ({
  prices,
  currency,
  loading,
  boldLabel,
  summaryLabel,
  taxLabel,
}) => {
  const styles = summaryLabelStyles();
  const { selectedCurrencyPrice } = useSelectedCurrencyPrice(prices);
  const { scrollToDisclaimer } = useScrollToSection();

  return (
    <Grid container={true} justifyContent={'space-between'} spacing={3} className={styles.lineContainer}>
      <SummaryLabelTitle
        label={
          <Box data-test="customise:summary:vehicle_selections" component="span" className={styles.label}>
            {summaryLabel}
            <IndicativeNumber
              dataTest="selections_label"
              className={clsx(styles.boldLabel, styles.indicativeText)}
              displayNumber={
                <Translation
                  id="trans__configurator__indicative_numbers__accessory"
                  className={styles.indicativeText}
                />
              }
              onClick={scrollToDisclaimer}
            />
          </Box>
        }
        boldLabel={boldLabel}
        colSm={8}
        colXs={6}
      />
      <PriceValue
        loading={loading}
        price={selectedCurrencyPrice}
        priceType={PriceDisplayType.PRIMARY}
        currency={currency}
        boldPrice={true}
        testId={'selections'}
        taxLabel={taxLabel}
      />
    </Grid>
  );
};

export default SummarySelection;
